import styled from "styled-components/macro";

export default styled.p`
  line-height: 1.6;
`;
